import { SVGAttributes } from 'react';

import Circle from './circle';
import Square from './square';
import Line from './line';
import Circle6 from './circle6';
import Circle8 from './circle8';
import Circle2H from './circle2h';
import Rectangle4CH from './rectangle4ch';
import Rectangle4CV from './rectangle4cv';
import Rectangle8C from './rectangle8c';
import Rectangle10C from './rectangle10c';
import Rectangle from './rectangle';
import Circle2V from './circle2v';

// here we register all the shapes that are available
// you can add your own here
export const ShapeComponents = {
  line: Line,
  
  circle: Circle,
  
  // 'round-rectangle': RoundRectangle,
  square: Square,
  
  // hexagon: Hexagon,
  // diamond: Diamond,
  // 'arrow-rectangle': ArrowRectangle,
  // cylinder: Cylinder,
  // triangle: Triangle,
  // parallelogram: Parallelogram,
  // plus: Plus,


  circle2h: Circle2H,
  circle2v: Circle2V,
  circle6: Circle6,
  circle8: Circle8,

  rectangle: Rectangle,
  rectangle4ch: Rectangle4CH,
  rectangle4cv: Rectangle4CV,
  rectangle8c: Rectangle8C,
  rectangle10c: Rectangle10C,
};

export type ShapeType = keyof typeof ShapeComponents;

export type ShapeProps = {
  width: number;
  height: number;
} & SVGAttributes<SVGElement>;

export type ShapeComponentProps = Partial<ShapeProps> & { type: ShapeType };
